import { MESH_GRADIENT_PALETTE, MeshGradient } from '@khal-os/ui';
import { useEffect, useState } from 'react';

// Re-bind without top-level spread — rolldown tree-shakes the LHS but keeps
// the side-effecty spread, crashing module init when imports aren't yet
// resolved. See DesktopBackground.tsx for the full note.
const PALETTE: readonly string[] = MESH_GRADIENT_PALETTE;

function StaticFallback() {
	return (
		<div
			style={{
				width: '100%',
				height: '100%',
				background: `linear-gradient(135deg, ${PALETTE[0]} 0%, ${PALETTE[3]} 50%, ${PALETTE[7]} 100%)`,
			}}
		/>
	);
}

/**
 * Mesh gradient background -- LP-matched shader params.
 *
 * LP hero uses: speed=0.8, distortion=0.6, swirl=0.4, fit=cover
 * OS desktop uses speed=0.3 for a calmer persistent background,
 * but keeps the same color palette and composition.
 */
export function MeshGradientBackground() {
	const [tabVisible, setTabVisible] = useState(true);

	useEffect(() => {
		const onVisibilityChange = () => {
			setTabVisible(document.visibilityState === 'visible');
		};
		document.addEventListener('visibilitychange', onVisibilityChange);
		return () => document.removeEventListener('visibilitychange', onVisibilityChange);
	}, []);

	if (!tabVisible) {
		return <StaticFallback />;
	}

	return <MeshGradient colors={Array.from(PALETTE)} speed={0.3} style={{ width: '100%', height: '100%' }} />;
}
